module.exports = __webpack_public_path__ + "img/turbo_off.dc17a704.svg";